var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunicationThumbDownOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.463 21.275c.041.11.088.207.142.292.044.07.092.13.145.183L9 23l7-7V3H6c-.383 0-.75.117-1.1.35-.35.233-.6.517-.75.85l-3 7.05A2.014 2.014 0 001 12v2c0 .533.2 1 .6 1.4.4.4.867.6 1.4.6h5.45l-1.1 4.35v.35c0 .183.038.375.113.575zm2.15-1.716L11.02 14H3.03a.553.553 0 01-.03-.029v-1.956l.001-.008L5.962 5.05a.5.5 0 01.07-.05H14v10.172l-4.387 4.386zM18 16h4V3h-4v13z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunicationThumbDownOutline);
export default __webpack_public_path__ + "4e663479fabb45fad1fd04dcb4b961fe.svg";
export { ForwardRef as ReactComponent };